<template>
  <div v-if="editor" class="custom-editor-header" :class="{'small-header':small}">
    <div class="custom-editor-header-holder">
      <button @click="editor.chain().focus().toggleBold().run()" :disabled="!editor.can().chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }" title="bold">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_10535)"><path d="M8 11H12.5C13.163 11 13.7989 10.7366 14.2678 10.2678C14.7366 9.79893 15 9.16304 15 8.5C15 7.83696 14.7366 7.20107 14.2678 6.73223C13.7989 6.26339 13.163 6 12.5 6H8V11ZM18 15.5C18 16.0909 17.8836 16.6761 17.6575 17.2221C17.4313 17.768 17.0998 18.2641 16.682 18.682C16.2641 19.0998 15.768 19.4313 15.2221 19.6575C14.6761 19.8836 14.0909 20 13.5 20H6V4H12.5C13.381 4.00004 14.2425 4.25865 14.9779 4.74378C15.7132 5.2289 16.29 5.9192 16.6367 6.72907C16.9834 7.53894 17.0847 8.43276 16.9282 9.29969C16.7716 10.1666 16.3641 10.9685 15.756 11.606C16.4386 12.0013 17.0053 12.5692 17.3992 13.2526C17.7931 13.9361 18.0003 14.7112 18 15.5ZM8 13V18H13.5C14.163 18 14.7989 17.7366 15.2678 17.2678C15.7366 16.7989 16 16.163 16 15.5C16 14.837 15.7366 14.2011 15.2678 13.7322C14.7989 13.2634 14.163 13 13.5 13H8Z" fill="#212121"/></g><defs><clipPath id="clip0_2_10535"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :disabled="!editor.can().chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }" title="italic">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9659)"><path d="M15 20H7V18H9.927L12.043 6H9V4H17V6H14.073L11.957 18H15V20Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9659"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :disabled="!editor.can().chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }" title="strike">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9787)"><path d="M17.154 14C17.384 14.516 17.5 15.09 17.5 15.72C17.5 17.062 16.976 18.112 15.929 18.867C14.88 19.622 13.433 20 11.586 20C9.946 20 8.323 19.619 6.716 18.856V16.6C8.236 17.477 9.791 17.916 11.382 17.916C13.933 17.916 15.212 17.184 15.221 15.719C15.2263 15.422 15.1716 15.1269 15.0603 14.8515C14.9489 14.5761 14.7832 14.3259 14.573 14.116L14.453 13.999H3V11.999H21V13.999H17.154V14ZM13.076 11H7.629C7.45383 10.8403 7.29289 10.6656 7.148 10.478C6.716 9.92 6.5 9.246 6.5 8.452C6.5 7.216 6.966 6.165 7.897 5.299C8.83 4.433 10.271 4 12.222 4C13.693 4 15.101 4.328 16.444 4.984V7.136C15.244 6.449 13.929 6.106 12.498 6.106C10.018 6.106 8.779 6.888 8.779 8.452C8.779 8.872 8.997 9.238 9.433 9.551C9.869 9.864 10.407 10.113 11.046 10.301C11.666 10.481 12.343 10.715 13.076 11V11Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9787"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>

      <span class="separator-line"></span>

      <button @click="setLink" :class="{ 'is-active': editor.isActive('link') }" title="link">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_145_2)"><path d="M18.364 15.536L16.95 14.12L18.364 12.706C18.8316 12.2425 19.2031 11.6911 19.4571 11.0836C19.7111 10.4761 19.8425 9.82442 19.844 9.16597C19.8454 8.50752 19.7168 7.85527 19.4655 7.24666C19.2142 6.63806 18.8451 6.08508 18.3795 5.61949C17.9139 5.15389 17.361 4.78484 16.7524 4.53353C16.1437 4.28222 15.4915 4.15359 14.833 4.15503C14.1746 4.15647 13.5229 4.28796 12.9154 4.54193C12.3079 4.79591 11.7566 5.16737 11.293 5.635L9.87901 7.05L8.46401 5.636L9.88001 4.222C11.1928 2.90918 12.9734 2.17165 14.83 2.17165C16.6866 2.17165 18.4672 2.90918 19.78 4.222C21.0928 5.53483 21.8304 7.31539 21.8304 9.172C21.8304 11.0286 21.0928 12.8092 19.78 14.122L18.365 15.536H18.364ZM15.536 18.364L14.121 19.778C12.8082 21.0908 11.0276 21.8284 9.17101 21.8284C7.3144 21.8284 5.53383 21.0908 4.22101 19.778C2.90819 18.4652 2.17065 16.6846 2.17065 14.828C2.17065 12.9714 2.90819 11.1908 4.22101 9.878L5.63601 8.464L7.05001 9.88L5.63601 11.294C5.16838 11.7576 4.79692 12.3089 4.54294 12.9164C4.28896 13.5239 4.15748 14.1756 4.15604 14.834C4.1546 15.4925 4.28323 16.1447 4.53454 16.7533C4.78585 17.362 5.1549 17.9149 5.62049 18.3805C6.08609 18.8461 6.63906 19.2152 7.24767 19.4665C7.85627 19.7178 8.50853 19.8464 9.16698 19.845C9.82543 19.8435 10.4771 19.7121 11.0846 19.4581C11.6921 19.2041 12.2435 18.8326 12.707 18.365L14.121 16.951L15.536 18.365V18.364ZM14.828 7.757L16.243 9.172L9.17201 16.242L7.75701 14.828L14.828 7.758V7.757Z" fill="#212121"/></g><defs><clipPath id="clip0_145_2"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().unsetLink().run()" :disabled="!editor.isActive('link')" title="unlink">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_145_6)"><path d="M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.536L16.95 14.12L18.364 12.706C18.8316 12.2424 19.2031 11.6911 19.4571 11.0836C19.711 10.4761 19.8425 9.82442 19.844 9.16597C19.8454 8.50751 19.7168 7.85526 19.4655 7.24666C19.2142 6.63805 18.8451 6.08508 18.3795 5.61948C17.9139 5.15389 17.3609 4.78484 16.7523 4.53353C16.1437 4.28221 15.4915 4.15359 14.833 4.15503C14.1746 4.15647 13.5229 4.28795 12.9154 4.54193C12.3079 4.7959 11.7566 5.16737 11.293 5.635L9.879 7.05L8.464 5.636L9.88 4.222C11.1928 2.90918 12.9734 2.17164 14.83 2.17164C16.6866 2.17164 18.4672 2.90918 19.78 4.222C21.0928 5.53482 21.8304 7.31539 21.8304 9.172C21.8304 11.0286 21.0928 12.8092 19.78 14.122L18.365 15.536H18.364ZM15.536 18.364L14.121 19.778C12.8082 21.0908 11.0276 21.8284 9.171 21.8284C7.31439 21.8284 5.53382 21.0908 4.221 19.778C2.90818 18.4652 2.17064 16.6846 2.17064 14.828C2.17064 12.9714 2.90818 11.1908 4.221 9.878L5.636 8.464L7.05 9.88L5.636 11.294C5.16837 11.7576 4.7969 12.3089 4.54293 12.9164C4.28895 13.5239 4.15747 14.1756 4.15603 14.834C4.15459 15.4925 4.28321 16.1447 4.53453 16.7533C4.78584 17.3619 5.15489 17.9149 5.62048 18.3805C6.08608 18.8461 6.63905 19.2152 7.24766 19.4665C7.85626 19.7178 8.50851 19.8464 9.16696 19.845C9.82541 19.8435 10.4771 19.712 11.0846 19.4581C11.6921 19.2041 12.2434 18.8326 12.707 18.365L14.121 16.951L15.536 18.365V18.364ZM14.828 7.757L16.243 9.172L9.172 16.242L7.757 14.828L14.828 7.758V7.757Z" fill="#212121"/></g><defs><clipPath id="clip0_145_6"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
<!--      <button @click="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'is-active': editor.isActive('codeBlock') }" title="Code block">-->
<!--        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_10636)"><path d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM4 5V19H20V5H4ZM20 12L16.464 15.536L15.05 14.121L17.172 12L15.05 9.879L16.464 8.464L20 12ZM6.828 12L8.95 14.121L7.536 15.536L4 12L7.536 8.464L8.95 9.88L6.828 12ZM11.244 17H9.116L12.756 7H14.884L11.244 17Z" fill="#212121"/></g><defs><clipPath id="clip0_2_10636"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>-->
<!--      </button>-->
<!--      <button title="spoiler" @click="addSpoiler" :class="{ 'is-active': spoilerToogle }">-->
<!--        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.63 8.35946C20.1233 8.83874 20.1233 9.61581 19.63 10.0951L12.8932 16.6405C12.3999 17.1198 11.6001 17.1198 11.1068 16.6405L4.36997 10.0951C3.87668 9.61581 3.87668 8.83874 4.36997 8.35946C4.86326 7.88018 5.66305 7.88018 6.15635 8.35946L12 14.0371L17.8437 8.35946C18.3369 7.88018 19.1367 7.88018 19.63 8.35946Z" fill="black"/></svg>-->
<!--      </button>-->
      <span class="separator-line"></span>
      <button title="pre" @click="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'is-active': editor.isActive('codeBlock') }">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_145_10)"><path d="M24 12L18.343 17.657L16.929 16.243L21.172 12L16.929 7.757L18.343 6.343L24 12ZM2.828 12L7.071 16.243L5.657 17.657L0 12L5.657 6.343L7.07 7.757L2.828 12ZM9.788 21H7.66L14.212 3H16.34L9.788 21Z" fill="#212121"/></g><defs><clipPath id="clip0_145_10"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      

      <button @click="showsrc" title="Source code" :class="{ 'is-active': src }">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_9807)"><path d="M4 18V14.3C4 13.9022 3.84196 13.5206 3.56066 13.2393C3.27936 12.958 2.89782 12.8 2.5 12.8H2V11.2H2.5C2.69698 11.2 2.89204 11.1612 3.07403 11.0858C3.25601 11.0104 3.42137 10.8999 3.56066 10.7607C3.69995 10.6214 3.81044 10.456 3.88582 10.274C3.9612 10.092 4 9.89698 4 9.7V6C4 5.20435 4.31607 4.44129 4.87868 3.87868C5.44129 3.31607 6.20435 3 7 3H8V5H7C6.73478 5 6.48043 5.10536 6.29289 5.29289C6.10536 5.48043 6 5.73478 6 6V10.1C6.0001 10.521 5.86735 10.9313 5.62064 11.2725C5.37393 11.6136 5.02586 11.8682 4.626 12C5.02586 12.1318 5.37393 12.3864 5.62064 12.7275C5.86735 13.0687 6.0001 13.479 6 13.9V18C6 18.2652 6.10536 18.5196 6.29289 18.7071C6.48043 18.8946 6.73478 19 7 19H8V21H7C6.20435 21 5.44129 20.6839 4.87868 20.1213C4.31607 19.5587 4 18.7956 4 18V18ZM20 14.3V18C20 18.7956 19.6839 19.5587 19.1213 20.1213C18.5587 20.6839 17.7956 21 17 21H16V19H17C17.2652 19 17.5196 18.8946 17.7071 18.7071C17.8946 18.5196 18 18.2652 18 18V13.9C17.9999 13.479 18.1327 13.0687 18.3794 12.7275C18.6261 12.3864 18.9741 12.1318 19.374 12C18.9741 11.8682 18.6261 11.6136 18.3794 11.2725C18.1327 10.9313 17.9999 10.521 18 10.1V6C18 5.73478 17.8946 5.48043 17.7071 5.29289C17.5196 5.10536 17.2652 5 17 5H16V3H17C17.7956 3 18.5587 3.31607 19.1213 3.87868C19.6839 4.44129 20 5.20435 20 6V9.7C20 10.0978 20.158 10.4794 20.4393 10.7607C20.7206 11.042 21.1022 11.2 21.5 11.2H22V12.8H21.5C21.1022 12.8 20.7206 12.958 20.4393 13.2393C20.158 13.5206 20 13.9022 20 14.3V14.3Z" fill="#212121"/></g><defs><clipPath id="clip0_2_9807"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>

      <span class="separator-line"></span>

      <button @click="editor.chain().focus().undo().run()" :disabled="!editor.can().chain().focus().undo().run()" title="undo">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_8702)"><path d="M5.828 6.9998L8.364 9.5358L6.95 10.9498L2 5.9998L6.95 1.0498L8.364 2.4638L5.828 4.9998H13C15.1217 4.9998 17.1566 5.84266 18.6569 7.34295C20.1571 8.84324 21 10.8781 21 12.9998C21 15.1215 20.1571 17.1564 18.6569 18.6567C17.1566 20.157 15.1217 20.9998 13 20.9998H4V18.9998H13C14.5913 18.9998 16.1174 18.3677 17.2426 17.2424C18.3679 16.1172 19 14.5911 19 12.9998C19 11.4085 18.3679 9.88238 17.2426 8.75716C16.1174 7.63195 14.5913 6.9998 13 6.9998H5.828Z" fill="#212121"/></g><defs><clipPath id="clip0_2_8702"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
      <button @click="editor.chain().focus().redo().run()" :disabled="!editor.can().chain().focus().redo().run()" title="redo">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2_8678)"><path d="M18.172 6.9998H11C9.4087 6.9998 7.88258 7.63195 6.75736 8.75716C5.63214 9.88238 5 11.4085 5 12.9998C5 14.5911 5.63214 16.1172 6.75736 17.2424C7.88258 18.3677 9.4087 18.9998 11 18.9998H20V20.9998H11C8.87827 20.9998 6.84344 20.157 5.34315 18.6567C3.84285 17.1564 3 15.1215 3 12.9998C3 10.8781 3.84285 8.84324 5.34315 7.34295C6.84344 5.84266 8.87827 4.9998 11 4.9998H18.172L15.636 2.4638L17.05 1.0498L22 5.9998L17.05 10.9498L15.636 9.5358L18.172 6.9998Z" fill="#212121"/></g><defs><clipPath id="clip0_2_8678"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </button>
    </div>
  </div>
  <editor-content class="custom-editor-body" :class="{'small-body':small}" :editor="editor" v-if="!src"/>
  <textarea class="src-code" @input="updateHTML" rows="10" :value="html" v-else></textarea>
</template>

<script>
  import StarterKit from '@tiptap/starter-kit'
  import Placeholder from '@tiptap/extension-placeholder'
  import Link from '@tiptap/extension-link'
  import TextStyle from '@tiptap/extension-text-style'
  import { Editor, EditorContent } from '@tiptap/vue-3'

  const CustomLink = Link.extend({
                                   addAttributes() {
                                     return {
                                       ...this.parent?.(),
                                       rel: {
                                         default: null,
                                       },
                                     };
                                   },
                                 });

  export default {
    components: {
      EditorContent,
    },
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: 'Введите текс сюда...',
      },
      small: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        editor: null,
        html: '',
        src: false,
        spoilerToogle: false
      }
    },
    methods:{
      showsrc(){
        this.src = !this.src
      },
      addSpoiler(){
        // this.spoilerToogle = !this.spoilerToogle;
        // this.editor.commands.toggleMark('span', { class: 'tg-spoiler' })

        let x = this.editor.getHTML();
        this.$emit('update:modelValue', x + '<span class="tg-spoiler">spoiler</span>');
        // this.editor.chain().focus().setContent(this.html).run()
      },
      updateHTML(e){
        let value = e.target.value;
        // this.editor.commands.setContent(value, false);
        this.html = value;
        this.$emit('update:modelValue', value);
        // this.modelValue = value;
      },
      setLink() {
        const previousUrl = this.editor.getAttributes('link').href;
        const url = window.prompt('URL', previousUrl);

        // cancelled
        if (url === null) {
          return
        }

        // empty
        if (url === '') {
          this.editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .unsetLink()
            .run()

          return
        }

        // update link
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .setLink({ href: url })
          .run()
      },
    },
    watch: {

      modelValue(value) {
        // HTML
        const isSame = this.editor.getHTML() === value;
        // JSON
        // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)
        if (isSame) {
          return
        }
        this.editor.commands.setContent(value, false);
        this.html = value
      },
    },
    mounted() {
      this.editor = new Editor({
                                 extensions: [
                                   StarterKit,
                                   TextStyle,
                                   CustomLink.configure({
                                                          HTMLAttributes: {
                                                            target: null,
                                                            rel: null,
                                                          },
                                                          openOnClick: false,
                                                        }),
                                   Placeholder.configure({placeholder: this.placeholder}),

                                 ],
                                 content: this.modelValue,
                                 onUpdate: () => {
                                   // HTML
                                   this.$emit('update:modelValue', this.editor.getHTML());
                                   this.html = this.editor.getHTML();
                                   // JSON
                                   // this.$emit('update:modelValue', this.editor.getJSON())
                                 },
                               });
      this.html = this.modelValue
    },
    beforeUnmount() {
      this.editor.destroy()
    },
  }
</script>

<style lang="scss">
  .src-code{
    width: 100%;
    background: transparent;
    border: none;
    resize: none;
  }
  .ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    color: #adb5bd;
    pointer-events: none;
    height: 0;
  }
  /* Basic editor styles */
  .separator-line{
    position: relative;
    display: block;
    width: 1px;
    height: 100%;
    opacity: 0.1;
    margin: 0 10px;
    background-color: #000;
  }
  .custom-editor-body{
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 30px 15px;
    -webkit-overflow-scrolling: touch;
    height: 250px;
    &.small-body{
      height: 180px;
    }
  }
  .custom-editor-header{
    padding: 5px;
    &.small-header{
      .separator-line{
        margin: 0 9px 0 6px;
        height: 28px;
        top: -2px;
      }

      button{
        width: 28px;
        height: 28px;
        margin-bottom: 3px;
        svg{
          width: 17px;
          height: 17px;
        }
      }
      .custom-editor-header-holder{
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        justify-content: flex-start;
        -webkit-justify-content: flex-start;
        height: auto;
        padding: 5px;
      }
    }
    .custom-editor-header-holder{
      box-shadow: 0px 4px 5px rgba(0,0,0,0.09);
      width: fit-content;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      padding: 0px 15px;
      border-radius: 5px;
      height: 55px;
      background-color: #fff;
    }

    button{
      background-color: transparent;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      justify-content:center;
      -moz-justify-content:center;
      -webkit-justify-content:center;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      width: 36px;
      height: 36px;
      margin-right: 5px;
      border: 0;
      cursor: pointer;
      padding: 0;
      position: relative;
      transition: all .2s cubic-bezier(0.165,0.84,0.44,1);
      -webkit-transition: all .2s cubic-bezier(0.165,0.84,0.44,1);
      color: #212121;
      &:hover{
        background-color: #e2e3eb;
      }
      &.is-active {
        background-color: #002c9b;
        &:hover{
          background-color: #002c9b;
        }
        path{
          fill:#FFF;
        }
      }

    }
  }
  .ProseMirror:focus{
    outline:none;
  }
  .ProseMirror {
    > * + * {
      margin-top: 0.75em;
    }
    ul,
    ol {
      padding: 0 1rem;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
    }
    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }
    pre {
      background: #0D0D0D;
      color: #FFF;
      font-family: 'JetBrainsMono', monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }
    img {
      max-width: 100%;
      height: auto;
    }
    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0D0D0D, 0.1);
    }
    hr {
      border: none;
      border-top: 2px solid rgba(#0D0D0D, 0.1);
      margin: 2rem 0;
    }
  }
</style>